import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageExtenderConfig } from '@/data/landingConfig/landingImageExtenderConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageExtender } from './schemaObject';

interface Props {}
const ImageExtender: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageExtender} />
			<LandingTemplate
				data={landingImageExtenderConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageExtender()}
			/>
		</>
	);
};

export default ImageExtender;
